import { useQuery } from 'react-query';
import { ParticipantService } from '../../../services/v1/interview_intelligence/ParticipantService';

export const useParticipants = (interviewId: number, expand?: string[]) =>
  useQuery({
    queryKey: ['participants', interviewId, { expand: expand }],
    queryFn: () => ParticipantService.list(interviewId, false, expand),
  });
